import ForceRefreshButton from "./ForceRefreshButton";

/**
 * Always-visible floating Refresh trigger in the bottom-left corner.
 * Tapping it opens the same ForceRefreshButton confirm dialog so users on
 * pages that don't render PageLayout/Dashboard topbars still have a one-click
 * way to clear cache + reload.
 */
export default function GlobalRefreshFab() {
  const userRole = typeof window !== "undefined" ? localStorage.getItem("role") : null;
  const userChapter = typeof window !== "undefined" ? localStorage.getItem("chapter") : null;

  return (
    <div
      className="fixed bottom-4 left-4 z-[900] flex items-center"
      data-testid="global-refresh-fab"
    >
      <div className="bg-slate-800/90 backdrop-blur border border-slate-600 rounded-full p-1 shadow-lg">
        <ForceRefreshButton userRole={userRole} userChapter={userChapter} compact />
      </div>
    </div>
  );
}
